import { Icon } from '@purpur/library/icon';
import styled from 'styled-components';

import { purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

import { HboMaxLogoRound } from './HboMaxLogoRound';

export const HboMaxIconModeDesktop = styled(HboMaxLogoRound)``;
export const HboMaxIconModeMobile = styled(Icon).attrs({ size: 'md' })``;
const hboMaxIconModeDesktopSelector: string = HboMaxIconModeDesktop;
const hboMaxIconModeMobileSelector: string = HboMaxIconModeMobile;

export const DualMode = styled.span.attrs({ role: 'presentation' })`
    ${purpurMedia('sm')`
        ${hboMaxIconModeDesktopSelector} { display: none; }
        ${hboMaxIconModeMobileSelector} { display: flex; }
    `}
    ${purpurMedia('lg')`
        ${hboMaxIconModeDesktopSelector} { display: flex; }
        ${hboMaxIconModeMobileSelector} { display: none; }
    `}
`;
